export const valueForKeyPath = (o, k, d = null) => {
  let keys = k.split('.');
  let key = keys.shift();
  let obj = o;
  while (key) {
    if (typeof obj !== 'object') {
      obj = null;
      break;
    }
    if (key in obj) {
      obj = obj[key];
    } else {
      obj = null;
      break;
    }
    key = keys.shift();
  }
  return obj || d;
};

export const removeAccents = function(text) {
  return text
    .toLowerCase()
    .replace(/[áàãâä]/gi, 'a')
    .replace(/[čç]/gi, 'c')
    .replace(/[ď]/gi, 'd')
    .replace(/[éèê]/gi, 'e')
    .replace(/[íìïî]/gi, 'i')
    .replace(/[ľĺ]/gi, 'l')
    .replace(/[ñň]/gi, 'n')
    .replace(/[óòöôõ]/gi, 'o')
    .replace(/[ř]/gi, 'r')
    .replace(/[š]/gi, 's')
    .replace(/[ť]/gi, 't')
    .replace(/[úùüûů]/gi, 'u')
    .replace(/[ý]/gi, 'y')
    .replace(/[ž]/gi, 'z')
    .replace(/[^a-zA-Z0-9]/g, ' ');
};

export const slugify = function(text) {
  return removeAccents(text)
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '');
};

export const __ = string => {
  return string;
};

export const uuid = function() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  );
};

export const dataURLtoFile = (dataurl, filename) => {
  var [mimePart, dataPart] = dataurl.split(','),
    mime = mimePart.match(/:(.*?);/)[1],
    bstr = atob(dataPart),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
}



// WEBPACK FOOTER //
// ./src/js/utils.jsx